export const environment = {
  production: false,
  envName: "dev",
  applicationName: "Inmar.Healthcare.AuditPlus",
  applicationApplinkFeature: "AuditPlusUI",
  applicationDisplayName: "RX AUDIT MANAGEMENT",
  rootUrl: "http://dev-web-auditplus.healthcare.inmar.com",
  healthcareTopBar:
    'https://dev-web-auth.healthcare.inmar.com/Scripts/healthcare-topbar-v2.js',
  auth0: {
    domain: "https://qa-login.healthcare.inmar.com",
    clientId: "CdodcS5nw6Dg6r1q9viKZ6E1FUAWJgxB",
    refreshToken: true,
    scope: "openid profile email",
  },
  authZApiRoot: {
    url: "https://dev-api-authz.healthcare.inmar.com/v1.0",
    audience: "https://dev-api-authz.healthcare.inmar.com",
  },
  auditApiRoot: {
    url: "https://dev-api-auditplus.healthcare.inmar.com/v1.0/api",
    audience: "https://dev-api-auditplus.healthcare.inmar.com",
  },
  claimApiRoot: {
    url: "https://dev-api-claim.healthcare.inmar.com/v1.0/api",
    audience: "https://dev-api-claim.healthcare.inmar.com",
  },
  faxApiRoot: {
    url: "https://dev-api-fax.healthcare.inmar.com/v1.0/api",
    audience: "https://dev-api-fax.healthcare.inmar.com",
  },
  imageApiRoot: {
    url: "https://dev-api-imagerepository.healthcare.inmar.com/v1.0/api",
    audience: "https://dev-api-imagerepository.healthcare.inmar.com",
  },
  lookerAnalytics: {
    url: "https://devpfmanalytics.cloud.looker.com",
  },
  lookerAdminRoot: {
    url: "https://dev-api-lookeradmin.healthcare.inmar.com",
    audience: "https://dev-api-lookeradmin.healthcare.inmar.com",
  },
  helpDocName: "ManualClaimHelpV5.pdf",
  defaultListLimit: 9999, // API has logic on several Get-List endpoint that assumes 9999 is getting all for drop list
  appInsights: {
    instrumentationKey: "",
  },
  googleAnalytics: {
    key: "",
  },
};
